import React, { useEffect, useState } from "react";
import useWindowScrollPosition from "../../hooks/useWindowScrollPosition";
import { useSelector } from "react-redux";
import { translation } from "../../translation";
import {
  useAutoFillAiMutation,
  usePostCreateIdentifMutation,
} from "../../redux/appSlices/collaborator/collaboratorApiSlice";
import {
  useGenerateWalletPassMutation,
  useGenerateGoogleWalletPassMutation,
} from "../../redux/appSlices/generalApiSlice";
import { addCollaboratorToWallet } from "../../utils/wallet";
import IdentificationForm from "../Modal/IdentificationForm";
import ContactLock from "./ContactLock";
import useTracking from "../../hooks/useTracking";
import useCollaboratorRestriction from "../../hooks/useCollaboratorRestriction";
import AutoFillPopup from "../Modal/AutoFillPopup";

const AddToContactButtonFloat = ({ id, traking, user, dataProfile }) => {
  const lang =
    useSelector((state) => state.collaborator.collaboratorInfo.language) ??
    "fr";
  const collaborator = useSelector(
    (state) => state.collaborator.collaboratorInfo,
  );

  const { sendTracking } = useTracking();
  const scrollPosition = useWindowScrollPosition();
  const restriction = useCollaboratorRestriction();
  const [postCreateIdentif] = usePostCreateIdentifMutation();
  const [AutoFillAi] = useAutoFillAiMutation();
  const [generateWalletPass] = useGenerateWalletPassMutation();
  const [generateGoogleWalletPass] = useGenerateGoogleWalletPassMutation();

  const [fetchGetVcard, setFetchGetVcard] = useState(false);
  const [openIdentification, setOpenIdentification] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataRes, setDataRes] = useState("");
  const [openFormContactLock, setOpenFormContactLock] = useState(false);
  const [contactAccess, setContactAccess] = useState(false);
  const [showAuthFillPopup, setShowAuthFillPopup] = useState(false);
  const [userSharedInfo, setUserSharedInfo] = useState({
    email: "",
    first_name: "",
    last_name: "",
    phone: "",
    company: "",
    card: "",
  });
  const [isScanning, setIsScanning] = useState(false);
  const [fetchWalletPass, setFetchWalletPass] = useState(false);

  const handleAddToWallet = async () => {
    setFetchWalletPass(true);

    try {
      const walletType = await addCollaboratorToWallet({
        collaboratorId: collaborator._id,
        generateAppleWalletPass: generateWalletPass,
        generateGoogleWalletPass,
      });

      sendTracking({
        action: 66,
        collaborator_id: collaborator.collaborator_id,
        componant:
          walletType === "google"
            ? "GoogleWalletButtonFloat"
            : "AppleWalletButtonFloat",
      });
    } catch (error) {
      console.error("Error generating wallet pass:", error);
    } finally {
      setTimeout(() => {
        setFetchWalletPass(false);
      }, 2000);
    }
  };

  useEffect(() => {
    setContactAccess(!collaborator.contact_locked);
  }, [collaborator.contact_locked]);

  // to show the loading spinner
  useEffect(() => {
    if (fetchGetVcard) {
      const timeoutId = setTimeout(() => {
        setFetchGetVcard(false);
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [fetchGetVcard]);

  const handleDownload = () => {
    if (contactAccess) {
      const csvDataUri = `${process.env.REACT_APP_API_BASE_URL}/vcards/${collaborator._id}`;
      sendTracking({
        action: 65,
        collaborator_id: collaborator.collaborator_id,
        componant: "MainButton",
      });
      setTimeout(() => {
        window.open(csvDataUri, "_self");
      }, 2000);
    } else {
      setOpenFormContactLock(true);
    }
  };

  const handleIdentify = () => {
    postCreateIdentif({
      card: "",
      email: "",
      first_name: "",
      last_name: "",
      phone: "",
      identified_in: collaborator?._id,
      tracking: localStorage.getItem("tracking"),
      identification_methode: 0,
      user_token: localStorage.getItem("user_token"),
    })
      .unwrap()
      .then((res) => {
        localStorage.setItem("completerId", res.data.identification._id);
        setDataRes(res.data.identification);
        setOpenIdentification(true);
      })
      .catch((err) => {
        console.log(err);
        console.log("1111");
        setDataRes(err.data);
        console.log("2222");
        localStorage.setItem("completerId", err?.data?._id);
        console.log("3333‹");
        setOpenIdentification(true);
        console.log("4444");
      });
  };

  // Button Style

  const [button, setButton] = useState({
    fontSize: 15,
    visibility: "visible",
    transition:
      "visibility 0s ease 0s, opacity 0.2s linear 0s, color 0.15s ease-in-out 0s, background-color 0.15s ease-in-out 0s, border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s",
    width: "100%",
    marginRight: 21,
    background: collaborator?.branding?.color
      ? collaborator.branding.color
      : "black",
    color: "white",
    border: "none",
  });

  const shared_style = {
    fontSize: "15px",
    visibility: "visible",
    opacity: 1,
    transition:
      "visibility 0s, opacity 0.2s linear, color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out",
    width: "100%",
    // marginRight: "20px",
  };

  const button_styles = {
    style1: {
      ...shared_style,
      background: "white",
      color: "black",
      border: "none",
    },
    style2: {
      ...shared_style,
      background: collaborator?.branding?.color
        ? collaborator.branding.color
        : "black",
      // background: "black",
      color: "white",
    },
    style3: {
      ...shared_style,
      visibility: "hidden",
      opacity: 0,
    },
  };

  useEffect(() => {
    setTimeout(() => {
      try {
        var element_ = document.getElementById("show-btn");
        var a = element_.getBoundingClientRect();

        var footer_ = document.getElementById("footer-start");
        var f = footer_.getBoundingClientRect();

        if (a.y + 60 < window.scrollY) {
          if (f.y - f.height - 80 < window.scrollY) {
            setButton(button_styles.style1);
          } else {
            setButton(button_styles.style2);
          }
        } else {
          setButton(button_styles.style3);
        }
      } catch (error) {}
    }, 0);
  }, [scrollPosition]);

  const uploadImage = async (file) => {
    setShowAuthFillPopup(false);
    setOpenIdentification(true);

    setIsScanning(true);

    AutoFillAi(file)
      .then((result) => {
        setUserSharedInfo({
          email: result?.data?.data?.email,
          first_name: result?.data?.data?.firstName,
          last_name: result?.data?.data?.lastName,
          phone: (() => {
            let phone = result?.data?.data?.phone?.number || "";
            // Remove spaces, dashes, and dots — keep only digits
            phone = phone.replace(/[\s\-.]/g, "").replace(/\D/g, "");
            return phone;
          })(),
          function: result?.data?.data?.function,
          company: result?.data?.data?.companyName,
          card: result?.data?.data?.filename,
          prefix: (() => {
            let prefix = result?.data?.data?.phone?.prefix || "";
            prefix = prefix.trim().replace(/\s+/g, "");
            if (prefix && !prefix.startsWith("+")) {
              prefix = `+${prefix}`;
            }
            return prefix;
          })(),
        });

        setIsScanning(false);
      })
      .catch((error) => {
        console.error(error);
        setShowAuthFillPopup(true);
        setOpenIdentification(false);
        setIsScanning(false);
      });
  };

  return (
    <div className="z-[10] max-full mx-auto">
      <section className="flex flex-col !gap-[10px] fixed bottom-0 w-full max-w-[540px] mx-auto z-[10] py-[18px]">
        {collaborator.form ? (
          <>
            <div className="flex !justify-between items-center !gap-[10px]">
              <button
                className="h-[50px] !w-[12rem] text-white bg-black rounded-md !text-[13px] flex items-center justify-center gap-3"
                style={button}
                id="btn-get-contact-2"
                onClick={handleDownload}
              >
                <span className="inline-block max-w-[100px]">
                  {!fetchGetVcard ? (
                    translation?.mainButton?.addContact?.[lang]
                  ) : (
                    <img
                      src="/assets/img/loaders/loading.gif"
                      alt="loading Vcard"
                      className="w-[23px] h-[23px]"
                    />
                  )}
                </span>
              </button>
              <button
                className="h-[50px] !w-[12rem] text-white bg-black rounded-md !text-[13px] !mr-[40px] ss:!mr-[20px]"
                style={button}
                onClick={handleIdentify}
              >
                <span className="inline-block max-w-[100px]">
                  {translation?.mainButton?.identifyContact?.[lang]}
                </span>
              </button>
            </div>
            {/* <button
              className={`h-[50px] w-full rounded-md text-[13px] flex items-center justify-center gap-2 ${
                lang === "ar"
                  ? "!ml-[40px] ss:!ml-[20px]"
                  : "!mr-[40px] ss:!mr-[20px]"
              }`}
              style={button}
              onClick={handleAddToWallet}
            >
              {!fetchWalletPass ? (
                <>
                  <img src="/assets/img/icons/wallet-icon.svg" alt="wallet" className="w-5 h-5" />
                  <span className="inline-block max-w-[110px]">
                    {translation?.mainButton?.addToWallet?.[lang]}
                  </span>
                </>
              ) : (
                <img
                  src="/assets/img/loaders/loading.gif"
                  alt="loading"
                  className="w-[23px] h-[23px]"
                />
              )}
            </button> */}
          </>
        ) : (
          <>
            <button
              className={`h-[50px] w-full rounded-md text-base flex items-center justify-center gap-3 mx-auto ${
                lang === "ar"
                  ? "!ml-[40px] ss:!ml-[20px]"
                  : "!mr-[40px] ss:!mr-[20px]"
              }`}
              style={button}
              id="btn-get-contact-2"
              onClick={handleDownload}
            >
              <span className="inline-block w-full">
                {!fetchGetVcard ? (
                  translation?.mainButton?.addContact?.[lang]
                ) : (
                  <img
                    src="/assets/img/loaders/loading.gif"
                    alt="loading Vcard"
                    className="w-[23px] h-[23px]"
                  />
                )}
              </span>
            </button>
            {collaborator?.popcardEcard && (
              <button
                className={`h-[50px] w-full rounded-md text-[13px] flex items-center justify-center gap-2 mx-auto ${
                  lang === "ar"
                    ? "!ml-[40px] ss:!ml-[20px]"
                    : "!mr-[40px] ss:!mr-[20px]"
                }`}
                style={button}
                onClick={handleAddToWallet}
              >
                {!fetchWalletPass ? (
                  <>
                    <img
                      src="/assets/img/icons/wallet-icon.svg"
                      alt="wallet"
                      className="w-5 h-5"
                    />
                    <span className="inline-block max-w-[110px]">
                      {translation?.mainButton?.addToWallet?.[lang]}
                    </span>
                  </>
                ) : (
                  <img
                    src="/assets/img/loaders/loading.gif"
                    alt="loading"
                    className="w-[23px] h-[23px]"
                  />
                )}
              </button>
            )}
          </>
        )}
      </section>

      {openIdentification && collaborator.form && (
        <IdentificationForm
          show={openIdentification}
          close={setOpenIdentification}
          dataRes={dataRes}
          handleShowAuthFillPopup={() => {
            setShowAuthFillPopup(true);
            setOpenIdentification(false);
          }}
          userSharedInfo={userSharedInfo}
          isScanning={isScanning}
          setUserSharedInfo={setUserSharedInfo}
        />
      )}

      {showAuthFillPopup && collaborator.form && (
        <AutoFillPopup
          showPopup={showAuthFillPopup}
          setShowPopup={setShowAuthFillPopup}
          lang={lang}
          setOpenIdentification={setOpenIdentification}
          upload={uploadImage}
        />
      )}

      {openFormContactLock && (
        <ContactLock
          id={collaborator._id}
          setOpenFormContactLock={setOpenFormContactLock}
          contactAccess={contactAccess}
          setContactAccess={setContactAccess}
          handleDownload={handleDownload}
        />
      )}
    </div>
  );
};

export default AddToContactButtonFloat;
